import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsAuxRelayIP, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-aux-relay',
  templateUrl: './ds-aux-relay.component.html',
  styleUrls: ['./ds-aux-relay.component.css']
})
export class DsAuxRelayComponent implements OnInit, OnChanges {
  
    @Input() dsAuxRelayObj: DsAuxRelayIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock
  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      if (!this.dsAuxRelayObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
  
    }
   
  sectionNoteChangePM(_event: any) {
    this.dsAuxRelayObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsAuxRelayObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsAuxRelayObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
            (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
      }
    }
    reloadData(){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
      }
    }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("TCS for Trip Coil 1", !!this.dsAuxRelayObj.auxRelTripCoil1, " required to save Datasheet."),
        new ValidationItem("EE Note", !!this.dsAuxRelayObj.sectionNoteEE, " required to save Datasheet.")
      );
      if (this.dsAuxRelayObj.isAuxRelTripCoil2Applicable) {
        _validList.push(new ValidationItem("TCS for Trip Coil 2", !!this.dsAuxRelayObj.auxRelTripCoil2, " required to save Datasheet."));
      }
    }

    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsAuxRelayObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsAuxRelayObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsAuxRelayObj.auxRelTripCoil1 || !this.dsAuxRelayObj.sectionNoteEE) {
        return false;
      }
      if (this.dsAuxRelayObj.isAuxRelTripCoil2Applicable && !this.dsAuxRelayObj.auxRelTripCoil2) return false;
    }
    if (this.hasAccessPM) {
      if (!this.dsAuxRelayObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsAuxRelayObj.sectionNoteME) return false;
    }
    return true;
  }

}

